module.exports = __webpack_public_path__ + "img/divider.02783ff1.svg";